export default "__VITE_ASSET__rDFMMAnx__"